import React, { createContext } from 'react';
export var EditPickupPersonContext = createContext({
    openPickupPersonDrawer: false,
    setOpenPickupPersonDrawer: function () { return null; },
});
export function EditPickupPersonProvider(_a) {
    var children = _a.children;
    var _b = React.useState(false), openPickupPersonDrawer = _b[0], setOpenPickupPersonDrawer = _b[1];
    return (React.createElement(EditPickupPersonContext.Provider, { value: { openPickupPersonDrawer: openPickupPersonDrawer, setOpenPickupPersonDrawer: setOpenPickupPersonDrawer } }, children));
}
